import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { Building2, Inbox, Sparkles, FileText, Sofa, Hammer } from "lucide-react";

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)); }, []);
  if (!stats) return <p className="text-muted">Loading...</p>;

  const cards = [
    ["Total Projects", stats.total_projects, Building2, "/admin/projects"],
    ["Total Leads", stats.total_leads, Inbox, "/admin/leads"],
    ["New Leads", stats.new_leads, Sparkles, "/admin/leads"],
    ["Blog Posts", stats.blog_posts, FileText, "/admin/blog"],
    ["Interior Projects", stats.interior_projects, Sofa, "/admin/projects"],
    ["Construction Projects", stats.construction_projects, Hammer, "/admin/projects"],
  ];

  return (
    <div>
      <h1 className="text-2xl font-bold text-ink mb-6">Dashboard</h1>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
        {cards.map(([label, val, Icon, to]) => (
          <Link key={label} to={to} className="rounded-xl2 bg-white border border-line p-5 hover:shadow-soft transition-shadow" data-testid={`stat-${label.toLowerCase().replace(/\s/g, "-")}`}>
            <div className="flex items-center justify-between"><Icon className="text-gold" size={22} /><span className="text-3xl font-extrabold text-ink">{val}</span></div>
            <div className="text-sm text-muted mt-2">{label}</div>
          </Link>
        ))}
      </div>

      <div className="mt-8 rounded-xl2 bg-white border border-line p-6">
        <h2 className="font-bold text-ink mb-4">Recent Inquiries</h2>
        {stats.recent_leads?.length ? (
          <div className="divide-y divide-line">
            {stats.recent_leads.map((l) => (
              <div key={l.id} className="py-3 flex items-center justify-between gap-4">
                <div><div className="font-semibold text-ink text-sm">{l.name} · {l.phone}</div><div className="text-xs text-muted">{l.service || "General"} — {l.city || "—"}</div></div>
                <span className="text-xs px-2.5 py-1 rounded-full bg-beige text-ink">{l.status}</span>
              </div>
            ))}
          </div>
        ) : <p className="text-muted text-sm">No inquiries yet.</p>}
      </div>
    </div>
  );
}
